import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { useForm, Link } from '@inertiajs/react'

function PasswordsNew() {
  const { data, setData, post, processing } = useForm({
    email_address: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/passwords')
  }

  return (
    <AtlasPage narrow>
      <PageTitle title="Reset hasła" subtitle="Podaj swój adres e-mail" />
      <Separator />

      <p className="text-center text-sm text-ink-light mb-md">
        Wyślemy instrukcje resetowania hasła na podany adres.
      </p>

      <form onSubmit={handleSubmit} className="space-y-md">
        <div>
          <label className="block font-label text-xs text-frame uppercase tracking-wide mb-xs">
            Adres e-mail
          </label>
          <input
            type="email"
            value={data.email_address}
            onChange={(e) => setData('email_address', e.target.value)}
            className="form-input"
            required
            autoFocus
            autoComplete="email"
          />
        </div>

        <Separator />

        <div className="flex flex-col items-center gap-sm">
          <Button type="submit" disabled={processing}>
            Wyślij instrukcje
          </Button>
          <Link
            href="/session/new"
            className="font-label text-xs text-frame underline decoration-frame/30 hover:decoration-frame"
          >
            Powrót do logowania
          </Link>
        </div>
      </form>

      <PageNumber number={21} />
    </AtlasPage>
  )
}

PasswordsNew.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default PasswordsNew
